import "./static/fonts/fonts.css"
import "./src/css/style.css"

// Skip prefetching page-data for every link in viewport/hover to cut CDN requests
export const disableCorePrefetching = () => true
